import { useGetArrows } from '../../../../hooks/useGetArrows'
import { ArrowLineHandler } from '../ArrowLineHandler'

const ArrowLinePoints = () => {
  const arrows = useGetArrows()

  return (
    <div>
      {arrows.map(
        (arrow) =>
          arrow.type !== 'smooth' &&
          arrow.visible && (
            <div key={arrow.id}>
              {arrow.points.map((point) => (
                <ArrowLineHandler
                  key={point.id}
                  arrowId={arrow.id}
                  id={point.id}
                  offset={point.offset}
                  opacityState={arrow.opacityState}
                  isArrowSelected={arrow.isSelected}
                />
              ))}
            </div>
          )
      )}
    </div>
  )
}

export default ArrowLinePoints
